import { createI18n } from 'vue-i18n'
import en from "./json/en.json"
// import fr from "./json/fr.json"
import it from "./json/it.json"

let localeArea = window.localStorage.getItem('selectedLangShort');

const i18n = createI18n({
    locale: localeArea,
    fallbackLocale: "en",
    fallbackWarn: false,
    missingWarn: false,
    warnHtmlMessage: false,
    messages: {
        en,
        fr: {},
        de: {},
        it
    },
});

export default i18n;